import { SyntheticEvent, useState } from "react";

import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Typography,
} from "@mui/material";

import { TLesson } from "../../../../../../@types";
import { lessonType } from "../../../../../../constants";

export type TCourseLessonProps = {
	lesson: TLesson;
};

export function CourseLesson({ lesson }: TCourseLessonProps) {
	const [expanded, setExpanded] = useState(false);

	const onChangeExpanded = (
		event: SyntheticEvent<Element, Event>,
		expanded: boolean,
	) => {
		setExpanded(expanded);
	};

	const renderLessonInfo = () => {
		const teachingTime = ((lesson.teachingTime ?? 0) / 60).toFixed(2);
		const flightTime = ((lesson.flightTime ?? 0) / 60).toFixed(2);
		const blockTime = ((lesson.blockTime ?? 0) / 60).toFixed(2);

		return (
			<>
				<Typography whiteSpace="break-spaces" className="normal-text">
					{lesson.description}
				</Typography>
				<div className="lesson-time-container">
					<div className="blue-dot" />
					<Typography flex={1} className="normal-text">
						{`${teachingTime} hours of Knowledge Development.`}
					</Typography>
				</div>
				{lesson.type === lessonType.ONSITE && (lesson.flightTime ?? 0) > 0 && (
					<div className="lesson-time-container">
						<div className="blue-dot" />
						<Typography flex={1} className="normal-text">
							{`${flightTime} hours of flight time to Develop Skill.`}
							{lesson.airplane && (
								<Typography component="span" className="normal-text">
									{` Airplane: ${lesson.airplane}`}
								</Typography>
							)}
						</Typography>
					</div>
				)}
				<div className="lesson-time-container">
					<div className="blue-dot" />
					<Typography className="normal-text">{`${blockTime} hours Total.`}</Typography>
				</div>
			</>
		);
	};

	return (
		<div className="course-lesson-item-container">
			<Accordion expanded={expanded} onChange={onChangeExpanded}>
				<AccordionSummary>
					<div style={{ width: "100%" }}>
						<Typography className="normal-text bold lesson-title">
							{lesson.title}
						</Typography>
						{!expanded && (
							<Typography className="normal-text">
								{`${((lesson.blockTime ?? 0) / 60).toFixed(2)} hrs`}
							</Typography>
						)}
					</div>
				</AccordionSummary>
				<AccordionDetails style={{ padding: 0 }}>
					{renderLessonInfo()}
				</AccordionDetails>
			</Accordion>
		</div>
	);
}
